import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './Volunteers.css';

const Volunteers: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="volunteers-page">
      <div className="volunteers-hero">
        <div className="container">
          <h1 className="page-title">{t('volunteers.title')}</h1>
        </div>
      </div>

      <section className="volunteers-section">
        <div className="container">
          <div className="volunteers-content">
            <div className="volunteers-intro">
              <h2>{t('volunteers.intro.title')}</h2>
              <p>{t('volunteers.intro.description')}</p>
            </div>

            <div className="volunteer-benefits">
              <h2>{t('volunteers.benefits.title')}</h2>
              <div className="benefits-grid">
                <div className="benefit-card">
                  <div className="benefit-icon">🤝</div>
                  <h3>{t('volunteers.benefits.benefit1.title')}</h3>
                  <p>{t('volunteers.benefits.benefit1.description')}</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">💪</div>
                  <h3>{t('volunteers.benefits.benefit2.title')}</h3>
                  <p>{t('volunteers.benefits.benefit2.description')}</p>
                </div>
                <div className="benefit-card">
                  <div className="benefit-icon">🌟</div>
                  <h3>{t('volunteers.benefits.benefit3.title')}</h3>
                  <p>{t('volunteers.benefits.benefit3.description')}</p>
                </div>
              </div>
            </div>

            <div className="volunteer-cta">
              <h2>{t('volunteers.cta.title')}</h2>
              <p>{t('volunteers.cta.description')}</p>
              <button className="volunteer-button" onClick={() => navigate('/donate-anonymously')}>
                {t('volunteers.cta.button')}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Volunteers;


